// extracted by mini-css-extract-plugin
module.exports = {"WhiteColor":"#fff","BlackColor":"#333","GrayColor30":"#e5e5e5","GrayColor40":"#ccc","ErrorColor":"#f73423"};